export default "__VITE_ASSET__BUdgOVUn__"